var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSortIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2C18.0523 2 18.5 2.44772 18.5 3L18.5 16.4368C18.5 16.6025 18.6343 16.7368 18.8 16.7368L21.3488 16.7368C21.6049 16.7368 21.7433 17.0371 21.5768 17.2318L17.728 21.7333C17.6083 21.8734 17.3917 21.8734 17.272 21.7333L13.4232 17.2318C13.2567 17.0371 13.3951 16.7368 13.6512 16.7368L16.2 16.7368C16.3657 16.7368 16.5 16.6025 16.5 16.4368L16.5 3C16.5 2.44772 16.9477 2 17.5 2Z",
    fill: "#2A2A2A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 13,
    height: 2,
    rx: 1,
    fill: "#2A2A2A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#2A2A2A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#2A2A2A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 19,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#2A2A2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSortIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sort-icon.b19ca753.svg";
export { ForwardRef as ReactComponent };